// extracted by mini-css-extract-plugin
export default {"container":"SectionWrapper_container__96aNl","sidebar":"SectionWrapper_sidebar__tcBDD"};